import {useMutation, useQueryClient} from 'react-query';
import {patchSponsor} from '.';
import {toast} from 'react-toastify';
import {useNavigate} from 'react-router-dom';

const usePatchSponsor = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationKey: ['patchSponsor'],
    mutationFn: ({payload, guid}: patchSponsorProps) => {
      return patchSponsor(payload, guid);
    },
    onSuccess: () => {
      toast.success(
        'تغییرات با موفقیت ثبت شد. بعد از بررسی کارشناسان نتیجه به شما اعلام می‌شود.',
      );
      queryClient.invalidateQueries(['sponsorDetail']);
      navigate('/sponsor/activePlane');
    },
  });
  return {isLoading, patchPlan: mutate, isSuccess};
};

export default usePatchSponsor;
